/* eslint-disable no-shadow */

const state = {
    chatRoutes: [],
};

const mutations = {
    SET_CHAT_ROUTES(state, routes) {
        state.chatRoutes = routes;
    },
};

const actions = {
    addChatRoute({ commit, state }, route) {
        if (!state.chatRoutes.find(r => r.path.name === route.path.name)) {
            commit('SET_CHAT_ROUTES', [...state.chatRoutes, route]);
        }
    },
};

export default {
    namespaced: true, // Make sure this is here
    state,
    mutations,
    actions,
};
